import React, { useEffect, useState } from "react";
import logo from "../logo/icon-512.png";

const NAV_ITEMS = [
  { name: "About us", href: "#about" },
  // { name: "Core Values", href: "#services" }, // hidden with CoreValuesSection
  { name: "Philosophy", href: "#philosophy" },
  { name: "Products", href: "#products" },
  { name: "Contact", href: "#contact" },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close on Escape, and on resize past md so the panel can't linger behind the desktop nav
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event) => event.key === "Escape" && setIsOpen(false);
    const onResize = () => window.innerWidth >= 768 && setIsOpen(false);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("resize", onResize);
    };
  }, [isOpen]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        isScrolled || isOpen ? "bg-paper/85 backdrop-blur soft-1" : ""
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-[1fr_auto_1fr] items-center h-16">
          <a href="#hero" className="flex items-center gap-2.5 justify-self-start">
            <img src={logo} alt="Yuvi Labs" className="w-8 h-8 rounded-lg" />
            <span className="font-display font-normal text-xl tracking-tight">Yuvi&nbsp;Labs</span>
          </a>

          <nav className="justify-self-center hidden md:flex items-center gap-9 text-sm text-ink">
            {NAV_ITEMS.map((item) => (
              <a key={item.href} href={item.href} className="hover:text-rose transition">
                {item.name}
              </a>
            ))}
          </nav>

          <div className="col-start-3 justify-self-end flex items-center gap-1.5">
            <a
              href="#contact"
              className="btn-rose-glossy text-sm font-normal px-5 py-2.5 rounded-full"
            >
              <span>Get In Touch</span>
            </a>

            <button
              type="button"
              onClick={() => setIsOpen((open) => !open)}
              aria-expanded={isOpen}
              aria-controls="mobile-nav"
              aria-label={isOpen ? "Close menu" : "Open menu"}
              className="md:hidden -mr-1.5 p-2 rounded-lg text-ink hover:text-rose transition"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                aria-hidden="true"
              >
                {isOpen ? (
                  <>
                    <path d="M5 5l14 14" />
                    <path d="M19 5L5 19" />
                  </>
                ) : (
                  <>
                    <path d="M3.5 7h17" />
                    <path d="M3.5 12h17" />
                    <path d="M3.5 17h17" />
                  </>
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <nav
          id="mobile-nav"
          className="nav-panel md:hidden border-t border-ink/5 bg-paper/95 backdrop-blur"
        >
          <div className="max-w-6xl mx-auto px-5 sm:px-8 py-2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="nav-link"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
